var PRECISION = 10;

export { PRECISION };